var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreenBorderCircle = function SvgGreenBorderCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "117 0 17 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 280377"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.5 8.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5 8.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.1176399999999997,
    stroke: "#26890d",
    fill: "transparent"
  }))));
};
export default SvgGreenBorderCircle;